import { styled as t } from "@mui/material";
import e from "../../../temp-lib/assets/icons/icon-ronin.svg.js";
import n from "../../../temp-lib/components/share/apeiron/ApeironBlueButton.js";
import i from "../../../temp-lib/components/share/next/Image.js";
import { useTranslation as l } from "react-i18next";
import { jsxs as s, jsx as a } from "react/jsx-runtime";
const m = t(n)`
  --background-color: #1473e9;
  border-radius: 4px;
  color: white;
  flex: 1;
  font-size: 16px;
  gap: 6px;
  height: 50px;
  margin-bottom: 20px;
  margin-left: auto;
  width: 100%;
  :hover {
    filter: brightness(0.9);
  }
`, p = t(i)`
  filter: grayscale(100%) brightness(3);
  width: 24px;
  height: 24px;
`, d = ({
  onClick: o
}) => {
  const {
    t: r
  } = l();
  return /* @__PURE__ */ s(m, {
    onClick: o,
    children: [/* @__PURE__ */ a(p, {
      src: e
    }), r("login.general.button.connect_wallet")]
  });
};
export {
  d as default
};
//# sourceMappingURL=ConnectWalletButton.js.map
